/* Helpful Crowd renders ratings asynchronously; unrated cards stay empty. */
(() => {
  const selector = '.product-card-wrapper .hc-widget--card-rating';

  const sync = (widget) => {
    const rating = widget.querySelector('.hc-product-rating');
    const countText = rating?.querySelector('.hc-product-rating__review-count')?.textContent || '';
    const reviewCount = countText.match(/\d+/)?.[0];
    const fullStars = rating?.querySelectorAll('.hc-icon--star').length || 0;
    const halfStars = rating?.querySelectorAll('.hc-icon--star-half').length || 0;
    const hasValidRating = fullStars > 0 && Boolean(reviewCount);
    widget.classList.toggle('is-loaded', Boolean(hasValidRating));
    if (!hasValidRating || !rating) return;

    const ratingValue = (fullStars + halfStars * 0.5).toFixed(1);
    rating.dataset.kzincRating = ratingValue;
    rating.dataset.kzincReviewCount = reviewCount;
    widget.setAttribute('aria-label', `Evaluare ${ratingValue} din 5, din ${reviewCount} recenzii`);
  };

  const syncAll = () => document.querySelectorAll(selector).forEach(sync);
  const start = () => {
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        syncAll();
      });
    };

    syncAll();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
